// extracted by mini-css-extract-plugin
module.exports =  {"template22":"Template22-k3Gj__template22","tooltip":"Template22-LF6y__tooltip"};